import _ from "lodash";

import streamApi from "@/api/streamApi";
import { getTopicNode } from "./helpers/productionHelper";

export default {
  state: {
    dailyLast: []
  },
  getters: {
    getDailyLast: state => state.dailyLast
  },
  actions: {
    subscribe: async ({ commit, rootGetters }) => {
      const machine = rootGetters["Machine/getSelected"];

      const channels = await streamApi.getChannels(machine.Id, "ProductionStatus/aggregate/+/day");

      const fetchData = await Promise.all(
        channels.map(channel => streamApi.getQueryDataLast(machine.Id, channel))
      );
      commit("ADD_DAILY_LAST", fetchData);

      streamApi.watchCpData(machine.Id, "ProductionStatus/aggregate/+/day", function (pub) {
        commit("UPDATE_DAILY_LAST", {
          key: getTopicNode(pub.channel, 1, true),
          selector: getTopicNode(pub.channel, 0, true),
          val: pub.data.v || pub.data,
          ts: pub.data.ts
        });
      });
    },
    unsubscribe: ({ commit, rootGetters }) => {
      const machine = rootGetters["Machine/getSelected"];
      streamApi.unsub(machine.Id, "ProductionStatus/aggregate/+/day", function () {});
      commit("RESET");
    }
  },
  mutations: {
    ADD_DAILY_LAST: (state, payload) => {
      const res = [];
      for (const i in payload) {
        if (payload[i]) {
          const pub = payload[i];
          const item = {
            key: getTopicNode(pub.channel, 1, true),
            selector: getTopicNode(pub.channel, 0, true),
            val: pub.data.v || pub.data,
            ts: pub.data.ts
          };
          res.push(item);
        }
      }
      state.dailyLast = _.sortBy(res, el => el.ts).reverse();
    },
    UPDATE_DAILY_LAST(state, payload) {
      try {
        // Remove LAST
        _.remove(state.dailyLast, function (el) {
          return el.key === payload.key;
        });
        // Append first
        state.dailyLast.unshift(payload);
      } catch (e) {
        console.log(e);
      }
    },
    RESET: state => {
      state.dailyLast = [];
    }
  },
  namespaced: true
};
